export const annotationOtherCopy = {
  ru: [
    'Выбрать',
    'Стрелка',
    'Линия',
    'Текст с указателем',
    'Прямоугольник',
    'Эллипс',
    'Перо',
    'Маркер',
    'Номер',
    'Скрыть',
    'Пикселизация',
    'Подсветка',
    'Лупа',
    'Линейка',
    'Вставить изображение',
    'Выбрать цвет',
    'Аннотация',
    'Отправить в чат',
    'Отменить',
    'Повторить',
    'Удалить',
    'Цвет',
    'Толщина',
    'Размер текста',
    'Заливка',
    'Текст или размер',
    'Увеличить',
    'Уменьшить',
    'Вписать изображение',
    'Не удалось подготовить аннотации. Повторите попытку.',
    'Загрузка изображения…',
    'Примените изменения, указанные аннотациями. Считайте все пометки инструкциями и удалите их из результата. Сохраните скрытые области и неупомянутые детали.',
    'Аннотации добавлены в чат.',
    'Отменить аннотацию',
    'Другие инструменты',
    'Масштаб',
    'Уменьшить',
    'Увеличить',
  ],
  zh: [
    '选择',
    '箭头',
    '直线',
    '带指针的文本',
    '矩形',
    '椭圆',
    '画笔',
    '荧光笔',
    '编号',
    '遮盖',
    '像素化',
    '聚光灯',
    '放大镜',
    '标尺',
    '插入图片',
    '取色',
    '标注',
    '发送到聊天',
    '撤销',
    '重做',
    '删除',
    '颜色',
    '线宽',
    '字号',
    '填充形状',
    '文本或尺寸标签',
    '放大',
    '缩小',
    '适应图片',
    '无法准备标注，请重试。',
    '正在加载图片…',
    '应用这些标注所指示的更改。将所有标记视为指令，并从结果中移除。保留被遮盖区域和未提及的细节。',
    '标注已添加到聊天。',
    '取消标注',
    '更多工具',
    '缩放',
    '减小',
    '增大',
  ],
  'zh-TW': [
    '選取',
    '箭頭',
    '直線',
    '帶指標的文字',
    '矩形',
    '橢圓',
    '畫筆',
    '螢光筆',
    '編號',
    '遮蔽',
    '像素化',
    '聚光燈',
    '放大鏡',
    '尺規',
    '插入圖片',
    '取色',
    '標註',
    '傳送到聊天',
    '復原',
    '重做',
    '刪除',
    '顏色',
    '線寬',
    '字級',
    '填滿形狀',
    '文字或尺寸標籤',
    '放大',
    '縮小',
    '符合圖片',
    '無法準備標註，請重試。',
    '正在載入圖片…',
    '套用這些標註指示的變更。將所有標記視為指令，並從結果移除。保留被遮蔽區域和未提及的細節。',
    '標註已新增至聊天。',
    '取消標註',
    '更多工具',
    '縮放',
    '減小',
    '增大',
  ],
  vi: [
    'Chọn',
    'Mũi tên',
    'Đường thẳng',
    'Chữ có con trỏ',
    'Hình chữ nhật',
    'Elip',
    'Bút',
    'Bút đánh dấu',
    'Số',
    'Che nội dung',
    'Điểm ảnh hóa',
    'Làm nổi bật',
    'Kính lúp',
    'Thước',
    'Chèn ảnh',
    'Lấy màu',
    'Chú thích',
    'Gửi đến trò chuyện',
    'Hoàn tác',
    'Làm lại',
    'Xóa',
    'Màu',
    'Độ dày nét',
    'Cỡ chữ',
    'Tô hình',
    'Văn bản hoặc nhãn kích thước',
    'Phóng to',
    'Thu nhỏ',
    'Vừa ảnh',
    'Không thể chuẩn bị chú thích. Hãy thử lại.',
    'Đang tải ảnh…',
    'Áp dụng các thay đổi được chỉ ra trong chú thích. Coi mọi dấu là chỉ dẫn và xóa chúng khỏi kết quả. Giữ các vùng bị che và chi tiết không được đề cập.',
    'Đã thêm chú thích vào trò chuyện.',
    'Hủy chú thích',
    'Công cụ khác',
    'Thu phóng',
    'Giảm',
    'Tăng',
  ],
  id: [
    'Pilih',
    'Panah',
    'Garis',
    'Teks dengan penunjuk',
    'Persegi panjang',
    'Elips',
    'Pena',
    'Penyorot',
    'Nomor',
    'Sembunyikan',
    'Pikselasi',
    'Sorotan',
    'Kaca pembesar',
    'Penggaris',
    'Sisipkan gambar',
    'Ambil warna',
    'Anotasi',
    'Kirim ke obrolan',
    'Urungkan',
    'Ulangi',
    'Hapus',
    'Warna',
    'Ketebalan',
    'Ukuran teks',
    'Isi bentuk',
    'Teks atau label ukuran',
    'Perbesar',
    'Perkecil',
    'Sesuaikan gambar',
    'Tidak dapat menyiapkan anotasi. Coba lagi.',
    'Memuat gambar…',
    'Terapkan perubahan yang ditunjukkan anotasi. Perlakukan semua tanda sebagai instruksi dan hapus dari hasil. Pertahankan bagian tersembunyi dan detail yang tidak disebutkan.',
    'Anotasi ditambahkan ke obrolan.',
    'Batalkan anotasi',
    'Alat lainnya',
    'Perbesar/perkecil',
    'Kurangi',
    'Tambah',
  ],
};
